import { render, staticRenderFns } from "./BatchDetails.vue?vue&type=template&id=b3700e70&"
import script from "./BatchDetails.vue?vue&type=script&lang=js&"
export * from "./BatchDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports